"use client";
import React, { useState, useEffect } from "react";
import { get_ir_news } from "@/spotlight/client";
import { cn } from "@/storyblok/utils/cn";
import StoryBlokLink from "@/storyblok/utils/links/StoryBlokLink";
import NewsListItem from "@/library/components/news/NewsListItem";
import Title from "@/library/sections/texts/Title";
import SpotlightNewsPagination from "@/library/components/paginations.jsx/SpotlightNewsPagination";

export default function SpotlightNewsGridBlock({ blok }) {
  const {
    numberOfItems,
    title,
    titleAs = "h1",
    titleColor,
    backgroundColor,
    isGrid,
  } = blok;
  const [newsList, setNewsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const func = async () => {
      const newsList_ = await get_ir_news({ numberOfItems });
      setNewsList(newsList_);
      setIsLoading(false);
    };
    try {
      func();
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
    func();
  }, [isGrid, numberOfItems]);

  const backgroundClasses = cn({
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  const newsGridClasses = isGrid
    ? cn(
        "grid grid-cols-1 md:grid-cols-3 md:justify-items-center md:px-0 my-12 gap-y-12 md:gap-x-12 divide-y-2 divide-gray-300 md:divide-y-0 md:divide-x-2"
      )
    : cn("flex flex-col gap-y-12");

  return (
    <section className={`${backgroundClasses}`}>
      <div className="max-w-7xl mx-auto px-8 py-12 ">
        <Title
          title={title}
          titleColor={titleColor}
          titleAs={titleAs}
          className={"font-bold sm:text-center sm:mb-28 mt-8  md:pl-0"}
        />
        {isLoading && <div className="text-center h-screen">Loading...</div>}
        {!isLoading && (
          <>
            {isGrid && (
              <>
                {newsList && newsList.length && (
                  <div className={newsGridClasses}>
                    {newsList.map((item) => (
                      <NewsListItem key={item.newsId} item={item} />
                    ))}
                  </div>
                )}
                {blok.readMoreLink && (
                  <div className="flex justify-end">
                    <StoryBlokLink
                      link={blok.readMoreLink}
                      buttonText={blok.readMoreTitle}
                      buttonType="textOnly"
                    />
                  </div>
                )}
              </>
            )}

            {!isGrid && (
              <SpotlightNewsPagination
                items={newsList}
                wrapperClassName="grid grid-cols-1 gap-6"
              />
            )}
          </>
        )}
      </div>
    </section>
  );
}
